var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUbq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_33006)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00EA90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2459 4.22314L14.6205 6.51139L10.4057 9.09496L10.2459 4.22314ZM7.75405 13.7525L3.37949 11.4642L7.5943 8.88008L7.75405 13.7525Z",
    fill: "white",
    fillOpacity: 0.698
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6205 11.6319L8.53817 15.1875V10.1987L14.6205 6.5115V11.6319ZM3.37949 6.34444L9.4618 2.8125V7.78162L3.37949 11.4643V6.34387V6.34444Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_33006"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbq);
export default __webpack_public_path__ + "static/media/ubq.ebc5325eea9d6fb8201b889f19f01c48.svg";
export { ForwardRef as ReactComponent };